import * as _ from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  setSocketData,
  setSocketRealTimeUpdate,
  setSocketRealTimeUpdateData,
} from "src/store/slices/asset.slice";
import Cookies from "universal-cookie";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import brandImage from "../../../../src/assets/images/hdb_logo.png";
import ProfileComponent from "../../../modules/profile/profile.component";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { fetchModules } from "../../../store/slices/navbar.slice";
import { setNotifications } from "../../../store/slices/notification.slice";
import { setAttemptedRoute } from "../../../store/slices/route-state.slice";
import { getUserInfo, isLoggedIn } from "../../auth/auth.service";
import { ROOT_MODULE_ACTION } from "../../enums/module-name-enums";
import HasPermission from "../../guards/has-permission";
import "./navbar.scss";
import MastheadComponent from "../masthead/masthead.component";

const Header = () => {
  const location = useLocation();
  const navConfig = useAppSelector((state: any) => state.navConfig.config);
  const modules = useAppSelector((state: any) => state.navbar.modules);
  const dispatch = useAppDispatch();
  const [showProfile, setShowProfile] = useState(false);
  // const [biomeModules, setBiomeModules] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const profileRef = useRef<HTMLDivElement>(null);
  const notificationRef = useRef<HTMLDivElement>(null);
  const currentEnvironment = process.env.REACT_APP_CURRENT_ENVIRONMENT;

  const isUserLoggedIn = isLoggedIn();

  // notification socket starts
  const [socketStatus, setSocketStatus] = useState("initial");
  const [isCallRetry, setIsCallRetry] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const socketRealTimeUpdate = useSelector(
    (state: any) => state.asset.socketRealTimeUpdate
  );

  const connectSocket = useCallback(() => {
    const notificationClient = new W3CWebSocket(
      `${process.env.REACT_APP_WS_BASE_URL}/slpapp/push`
    );

    notificationClient.onopen = () => {
      console.log("WebSocket notification Client Connected");
      setSocketStatus("open");
      notificationClient.send(
        JSON.stringify({ token: new Date().getUTCMilliseconds() })
      );
    };

    notificationClient.onmessage = (message) => {
      const copiedSocketRealTimeUpdate = _.cloneDeep(socketRealTimeUpdate);

      const data = JSON.parse(`${message.data}`);

      dispatch(setSocketRealTimeUpdateData(_.cloneDeep(data)));
      /*       const user = getUserInfo();

      if (
        user[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
        ] === data?.NotificationIdentifier
      ) {
        toast.success("Acknowledgement Received", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
        });
      } */

      switch (data.Type) {
        case 1:
          copiedSocketRealTimeUpdate.LightingOverride = true;
          break;
        case 2:
          copiedSocketRealTimeUpdate.SoftDimming = true;
          break;
        case 3:
          copiedSocketRealTimeUpdate.LightIntensity = true;
          break;
        case 4:
          copiedSocketRealTimeUpdate.TimeDelay = true;
          break;
        case 5:
          copiedSocketRealTimeUpdate.MotionSensor = true;
          break;
        case 6:
          copiedSocketRealTimeUpdate.PhotoSensing = true;
          break;
        case 7:
          copiedSocketRealTimeUpdate.RainSensor = true;
          break;
        case 8:
          copiedSocketRealTimeUpdate.TimerProfile = true;
          break;
        case 9:
          copiedSocketRealTimeUpdate.DimmingProfile = true;
          break;
        case 10:
          copiedSocketRealTimeUpdate.LuminanceProfile = true;
          break;
        case 11:
          copiedSocketRealTimeUpdate.DayLightProfile = true;
          break;
        case 12:
          copiedSocketRealTimeUpdate.RainProfile = true;
          break;
        case 13:
          copiedSocketRealTimeUpdate.DayLightHarvest = true;
          break;
        case 21:
          copiedSocketRealTimeUpdate.LightStatusReading = true;
          break;
        case 22:
          copiedSocketRealTimeUpdate.FirmwareVersion = true;
          break;
        case 23:
          copiedSocketRealTimeUpdate.GetGatewayConfigFromDevice = true;
          break;
        case 24:
          copiedSocketRealTimeUpdate.GeneralConfiguration = true;
          break;
        case 25:
          copiedSocketRealTimeUpdate.GetTimerProfileConfigFromDevice = true;
          break;
        case 26:
          copiedSocketRealTimeUpdate.GetDaylightProfileConfigFromDevice = true;
          break;
        case 27:
          copiedSocketRealTimeUpdate.GatewayZoneSetACK = true;
          break;

        default:
          break;
      }

      dispatch(setSocketRealTimeUpdate(copiedSocketRealTimeUpdate));
      dispatch(setSocketData(data));
    };

    notificationClient.onclose = (event) => {
      console.log("WebSocket notification Client Closed", event);

      setSocketStatus("closed");
      setIsCallRetry((prev: boolean) => !prev);
    };
  }, [socketStatus, isCallRetry]);

  useEffect(() => {
    if (socketStatus == "initial") {
      connectSocket();
    } else if (socketStatus == "closed") {
      setTimeout(() => {
        console.log(`Retrying Notification Client`);

        connectSocket();
      }, 5000);
    }
  }, [socketStatus, isCallRetry]);

  // notification socket ends

  // const notifications = useSelector((state: any) => {
  //   return state.notification.totalNotifications;
  // });

  const unsavedDetectorInitiated = useSelector((state: any) => {
    return state.routeState.unsavedDetectorInitiated;
  });

  const toggleDropdown = (name: string) => {
    if (name === "Profile") {
      setShowProfile(!showProfile);
    } else if (name === "Notification") {
      if (showNotification) {
        setShowNotification(false);
      } else {
        setShowNotification(true);
        dispatch(setNotifications(0));
      }
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      profileRef.current &&
      !profileRef.current.contains(event.target as Node)
    ) {
      setShowProfile(false);
    } else if (
      notificationRef.current &&
      !notificationRef.current.contains(event.target as Node) &&
      !notificationRef.current.parentElement?.contains(event.target as Node)
    ) {
      setShowNotification(false);
    }
  };

  const getModules = useCallback(() => {
    const user = getUserInfo();

    if (!user) return;

    dispatch(fetchModules({ RoleId: Number(user.roleid) })).then((res: any) => {
      if (res?.error?.message?.includes("status code 302")) {
        // navigate("/login-error", { replace: true });
        console.log("Redirecting to login-error page from front-end");
        window.location.href = "/login-error";
      }
    });
  }, []);

  // useEffect(() => {
  //   if (!modules?.length) return;
  //   const biomeModules: any = [];
  //   for (let module of modules) {
  //     const data = {
  //       title: module?.name,
  //       path: module?.url,
  //     };

  //     if (!biomeModules.some((module: any) => module.name === data.title)) {
  //       biomeModules.push(data);
  //     }
  //   }
  //   setBiomeModules(biomeModules);
  // }, [modules]);

  useEffect(() => {
    if (modules?.length) {
      const allAccessDenied = modules.every(
        (mod: any) => mod?.hasPermission === false
      ); // true if all hasAccess are false

      if (allAccessDenied) {
        toast.error("You don't have access to any module", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
        });

        // Clear local storage and cookies to logout the user.
        localStorage.clear();
        localStorage.setItem("isLogout", JSON.stringify(true));

        const cookies = new Cookies();
        cookies.remove("hdb-token", { path: "/" });
      }
    }
  }, [modules]);

  useEffect(() => {
    getModules();
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      {/* Singapore Government Agency Website Banner */}
      {currentEnvironment == "sit" ? null : (
        <MastheadComponent />
      )}

      {navConfig.hide ? (
        /* for mobile screen */
        <div className="navbar-header">
          <Navbar
            style={{ backgroundColor: "#0F477E" }}
            variant="light"
            // bg="light"
            expand={false}
            className="p-3"
          >
            <Container fluid>
              {currentEnvironment == "sit" ? null : (
                <Navbar.Brand as={NavLink} to="/">
                  <img className="siteLogoImg" src={brandImage} alt="sdb-slp" />
                </Navbar.Brand>
              )}

              {isUserLoggedIn && (
                <Navbar.Toggle
                  aria-controls={`offcanvasNavbar-expand`}
                  style={{ backgroundColor: "#ebebeb" }}
                  onClick={() => setShowOffcanvas(true)}
                />
              )}

              <Navbar.Offcanvas
                id={`offcanvasNavbar-expand`}
                aria-labelledby={`offcanvasNavbarLabel-expand`}
                placement="end"
                show={showOffcanvas}
                onHide={() => setShowOffcanvas(false)}
              >
                {currentEnvironment == "sit" ? null : (
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title id={`offcanvasNavbarLabel-expand`}>
                      <img
                        className="siteLogoImg"
                        src={brandImage}
                        alt="hdb-slp"
                      />
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                )}

                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1 pe-3">
                    {location?.pathname !== "/login" &&
                      location?.pathname.toLowerCase() !==
                      "/verify-master-data" && (
                        <>
                          {modules?.length
                            ? modules
                              ?.filter(
                                (module: any) =>
                                  module?.name?.toLowerCase() !== "test"
                              ) // hide Test module from navbar
                              ?.map((module: any, index: number) => (
                                <HasPermission
                                  moduleName={module?.name}
                                  isRoute={false}
                                  actionName={ROOT_MODULE_ACTION}
                                  key={index + 0}
                                >
                                  {module?.name !== "Profile" && (
                                    <Nav.Link
                                      key={index + 0}
                                      as={NavLink}
                                      onClick={() => {
                                        if (unsavedDetectorInitiated) {
                                          dispatch(
                                            setAttemptedRoute(module?.url)
                                          );
                                        }
                                        setShowOffcanvas(false);
                                      }}
                                      to={
                                        module?.name !== "Profile" &&
                                          !unsavedDetectorInitiated
                                          ? module?.url
                                          : null
                                      }
                                    >
                                      <div className="nav-item">
                                        <div className="">{module?.name}</div>
                                      </div>
                                    </Nav.Link>
                                  )}
                                </HasPermission>
                              ))
                            : ""}
                          <>
                            {isUserLoggedIn && (
                              <Nav.Link
                                key={modules?.length + 1}
                                onClick={() => toggleDropdown("Profile")}
                              >
                                <div className="profile-nav">
                                  <div className="nav-item mb-3">
                                    <div className="">Profile</div>
                                  </div>
                                  {showProfile && (
                                    <div className="profile" ref={profileRef}>
                                      <ProfileComponent onClickShowNavbar={() => setShowOffcanvas(false)} />
                                    </div>
                                  )}
                                </div>
                              </Nav.Link>
                            )}
                          </>
                        </>
                      )}
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        </div>
      ) : (
        /* for Desktop screen */
        <div className="navbar-header">
          <Navbar
            // bg="primary"
            style={{ backgroundColor: "#0F477E" }}
            variant="light"
          >
            <Container className="navbar-min-height-60">
              {currentEnvironment == "sit" ? null : (
                <Navbar.Brand as={NavLink} to={"/dashboard"}>
                  <img className="siteLogoImg" src={brandImage} alt="sdb-slp" />
                </Navbar.Brand>
              )}

              <Nav className="me-auto">
                {location?.pathname !== "/login" &&
                  location?.pathname.toLowerCase() !==
                  "/verify-master-data" && (
                    <>
                      {modules?.length
                        ? modules
                          ?.filter(
                            (module: any) =>
                              module?.name?.toLowerCase() !== "test"
                          ) // hide Test module from navbar
                          ?.map((module: any, index: number) => (
                            <HasPermission
                              moduleName={module?.name}
                              isRoute={false}
                              actionName={ROOT_MODULE_ACTION}
                              key={index + 0}
                            >
                              {module?.name !== "Profile" && (
                                <Nav.Link
                                  key={index + 0}
                                  as={NavLink}
                                  onClick={() => {
                                    if (unsavedDetectorInitiated) {
                                      dispatch(
                                        setAttemptedRoute(module?.url)
                                      );
                                    }
                                  }}
                                  to={
                                    module?.name !== "Profile" &&
                                      !unsavedDetectorInitiated
                                      ? module?.url
                                      : null
                                  }
                                >
                                  <div className="nav-item">
                                    <div className="">{module?.name}</div>
                                  </div>
                                </Nav.Link>
                              )}
                            </HasPermission>
                          ))
                        : ""}

                      <>
                        {/*                         <HasPermission
                          moduleName={"Profile"}
                          isRoute={false}
                          actionName={ROOT_MODULE_ACTION}
                        > */}
                        {isUserLoggedIn && (
                          <Nav.Link
                            key={modules?.length + 1}
                            onClick={() => toggleDropdown("Profile")}
                          >
                            <div className="profile-nav">
                              <div className="nav-item">
                                <div className="">Profile</div>
                              </div>
                              {showProfile && (
                                <div className="profile" ref={profileRef}>
                                  <ProfileComponent />
                                </div>
                              )}
                            </div>
                          </Nav.Link>
                        )}

                        {/* <Nav.Link
                            key={modules.length + 2}
                            onClick={() => {
                              toggleDropdown("Notification");
                            }}
                            title="Notifications"
                          >
                            <div className="notification-nav">
                              <div className="nav-item">
                                <div className="bell-icon">
                                  <FontAwesomeIcon
                                    icon={faBell}
                                    className="fs-7"
                                  />

                                  {notifications > 0 && (
                                    <span className="count">
                                      {notifications}
                                    </span>
                                  )}
                                </div>
                              </div>
                              {showNotification && (
                                <div
                                  className="notification"
                                  ref={notificationRef}
                                >
                                  <NotificationComponent />
                                </div>
                              )}
                            </div>
                          </Nav.Link> */}
                        {/* </HasPermission> */}
                      </>
                    </>
                  )}
              </Nav>
            </Container>
          </Navbar>
        </div>
      )}
    </div>
  );
};

export default Header;
